
import { } from '../dpitUtilsPublic';
import DpitTarget from './DpitTarget';
import DpitTargetParent from './DpitTargetParent';


export default class DpitTargetBranch {
	constructor(targetElement, dpDebugEn) {
		this.dpDebugEn = dpDebugEn;
		//this.initProcessData();
		this.initBranch(targetElement, dpDebugEn);
	}

	initProcessData() {
		this.isZIdxFixParent = false;
		this.closestFixedPosItem = null;
		this.fixedPosElements = [];
		this.stickyPosElements = [];
		this.scrollableElements = [];
	}


	initBranch(targetElement) {
		this.branchItems = [];
		if (targetElement) {
			let element = targetElement;
			let distance = 0;
			do {
				switch (distance) {
					case 0: this.branchItems.push(new DpitTarget(element)); break;
					default: this.branchItems.push(new DpitTargetParent(element)); break;
				}
				element = element.parentNode;
				distance++;
				if (!element.tagName || element.tagName.toLowerCase() === 'body') break;
			} while (element !== null);

		}
	}

	getTargetItem() {
		return this.branchItems[0];
	}

	containsFixed() {
		return this.fixedPosElements?.length > 0;
	}

	containsFixedParent() {
		return this.closestFixedPosItem?.element !== null;
	}

	getClosestFixedParent() {
		return this.closestFixedPosItem?.element;
	}

	getFirstScrollableChildFromClosestFixedParent() {
		if (!this.closestFixedPosItem?.element || !this.branchItems) return null;
		const closestFixedPosItemIdx = this.branchItems.indexOf(this.closestFixedPosItem, 1);
		if (closestFixedPosItemIdx > 0) {
			for (let distanceFromTarget = closestFixedPosItemIdx; distanceFromTarget > 0; distanceFromTarget--) {
				const item = this.branchItems[distanceFromTarget];
				if (item.analysis.isScrollable) {
					return item.element;
				}
			}
		}
	}

	containsSticky() {
		return this.stickyPosElements?.length > 0;
	}

	containsScrollable() {
		return this.scrollableElements?.length > 0;
	}

	process() {
		this.initProcessData();
		this.branchItems.forEach(item => {
			item.process(this.isZIdxFixParent);
			if (!this.isZIdxFixParent && item.needsZIndexFix) this.isZIdxFixParent = true;

			if (item.analysis.isFixed) {
				this.fixedPosElements.push(item.element);
				if (item !== this.getTargetItem()) {
					this.closestFixedPosItem = item;
				}
			}
			if (item.analysis.isSticky) this.stickyPosElements.push(item.element);
			if (item.analysis.isScrollable) this.scrollableElements.push(item.element);
		});
		if (this.dpDebugEn) console.log('[dpit] Branch analysis:', this.branchItems, this);
	}

	destroy() {
		this.branchItems.forEach(item => {
			item.destroy();
		});
	}


}